import * as R from 'ramda';
import { columns as BattingColumns } from './FormalGameBoxBatting';
import { columns as PitchingColumns } from './FormalGameBoxPitching';

export const verify = (awayBox, homeBox, PAList) => {
  const PA2Batters = {};
  const PA2Pitchers = {};

  const initPA2Batter = (batterUniqid) => {
    PA2Batters[batterUniqid] = {
      PA: 0,
      AB: 0,
      R: 0,
      H: 0,
      RBI: 0,
      '2B': 0,
      '3B': 0,
      HR: 0,
      GIDP: 0,
      BB: 0,
      IBB: 0,
      HBP: 0,
      SO: 0,
      SH: 0,
      SF: 0,
      SB: 0,
      CS: 0,
      E: 0,
    };
  };

  const initPA2Pitcher = (pitcherUniqid) => {
    PA2Pitchers[pitcherUniqid] = {
      IP_out: 0,
      BF: 0,
      NP: 0,
      S: 0,
      H: 0,
      HR: 0,
      BB: 0,
      IBB: 0,
      HB: 0,
      SO: 0,
      R: 0,
      ER: 0,
    };
  };

  const errorMessages = [];
  const missingMessages = [];
  PAList.forEach((PA) => {
    // 打者
    const batterUniqid = PA.batter.uniqid;
    if (!PA2Batters[batterUniqid]) {
      initPA2Batter(batterUniqid);
    }

    if (PA.result !== '') {
      PA2Batters[batterUniqid].PA++;
      if (PA.location_code === 'x') {
        missingMessages.push(`${PA.side} 打者：${PA.batter.name} ${PA.inning}局打席 ${PA.result} 缺少落點`);
      }
      if (PA.trajectory === 'x') {
        missingMessages.push(`${PA.side} 打者：${PA.batter.name} ${PA.inning}局打席 ${PA.result} 缺少彈道`);
      }
    }
    if (
      PA.result !== '' &&
      !['uBB', 'IBB', 'HBP', 'SH', 'SH_E', 'SH_FC', 'SF', 'SF_E', 'IH', 'IR'].includes(PA.result)
    ) {
      PA2Batters[batterUniqid].AB++;
    }
    switch (PA.result) {
      case 'SH_E':
      case 'SH_FC':
        PA2Batters[batterUniqid].SH++;
        break;
      case 'SF_E':
        PA2Batters[batterUniqid].SF++;
        break;
      case 'GIDP_E':
        PA2Batters[batterUniqid].GIDP++;
        break;
      case '1B':
      case '2B':
      case '3B':
      case 'HR':
        PA2Batters[batterUniqid].H++;
        break;
      case 'IHR':
        PA2Batters[batterUniqid].H++;
        PA2Batters[batterUniqid].HR++;
        break;
      case 'uBB':
      case 'IBB':
        PA2Batters[batterUniqid].BB++;
        break;
      default:
        break;
    }

    PA2Batters[batterUniqid].RBI += PA.RBI;
    if (PA.result in PA2Batters[batterUniqid]) {
      PA2Batters[batterUniqid][PA.result]++;
    }

    let runnerRBI = 0;
    PA.runners.forEach((runner) => {
      const runnerUniqid = runner.runner.uniqid;
      if (!PA2Batters[runnerUniqid]) {
        initPA2Batter(runnerUniqid);
      }
      switch (runner.code) {
        case 'SB':
          PA2Batters[runnerUniqid].SB++;
          break;
        case 'CS':
        case 'CS_E':
          PA2Batters[runnerUniqid].CS++;
          break;
        default:
          break;
      }
      if (runner.is_scoring) {
        PA2Batters[runnerUniqid].R++;
      }
      if (runner.is_RBI) {
        runnerRBI++;
      }
    });

    if (PA.RBI !== runnerRBI) {
      errorMessages.push(
        `${PA.side} ${PA.inning}局 ${PA.PA_order}棒 打者：${PA.batter.name} 打席 RBI ${PA.RBI} 與跑壘事件 RBI ${runnerRBI} 不匹配`,
      );
    }

    // 投手
    const pitcherUniqid = PA.pitcher.uniqid;
    if (!PA2Pitchers[pitcherUniqid]) {
      initPA2Pitcher(pitcherUniqid);
    }

    PA2Pitchers[pitcherUniqid].IP_out += PA.end_outs - PA.start_outs;
    if (PA.result !== '') {
      PA2Pitchers[pitcherUniqid].BF++;
    }
    switch (PA.result) {
      case '1B':
      case '2B':
      case '3B':
      case 'HR':
        PA2Pitchers[pitcherUniqid].H++;
        break;
      case 'IHR':
        PA2Pitchers[pitcherUniqid].H++;
        PA2Pitchers[pitcherUniqid].HR++;
        break;
      case 'uBB':
      case 'IBB':
        PA2Pitchers[pitcherUniqid].BB++;
        break;
      case 'HBP':
        PA2Pitchers[pitcherUniqid].HB++;
        break;
      default:
        break;
    }

    if (PA.result in PA2Pitchers[pitcherUniqid]) {
      PA2Pitchers[pitcherUniqid][PA.result]++;
    }

    PA.events.forEach((event) => {
      if (!event.pitch) {
        return;
      }

      if (!PA2Pitchers[event.pitcher.uniqid]) {
        initPA2Pitcher(event.pitcher.uniqid);
      }

      if (event.type !== 'PITCH') {
        return;
      }
      PA2Pitchers[event.pitcher.uniqid].NP++;
      if (event.is_strike) {
        PA2Pitchers[event.pitcher.uniqid].S++;
      }
    });

    PA.runners.forEach((runner) => {
      if (!runner.is_scoring) {
        return;
      }
      const countOnPitcherUniqid = runner.count_on_pitcher?.uniqid;

      if (!PA2Pitchers[countOnPitcherUniqid]) {
        initPA2Pitcher(countOnPitcherUniqid);
      }
      PA2Pitchers[countOnPitcherUniqid].R++;
      if (runner.is_ER) {
        PA2Pitchers[countOnPitcherUniqid].ER++;
      }
    });
  });

  const battingIgnoreList = ['DP', 'TP'];
  const pitchingIgnoreList = ['WP', 'BK'];

  [...awayBox.battings, ...homeBox.battings].forEach((batting) => {
    const batterUniqid = batting.player.uniqid;
    if (!PA2Batters[batterUniqid]) {
      initPA2Batter(batterUniqid);
    }

    R.filter((c) => !!c.updatable && !battingIgnoreList.includes(c.column), BattingColumns).forEach((c) => {
      const key = c.column;
      const PAValue = PA2Batters[batterUniqid][key];
      if (PAValue === batting[key]) {
        return;
      }

      errorMessages.push(
        `${R.find((b) => b.player.uniqid === batterUniqid, awayBox.battings) ? 'AWAY' : 'HOME'} 打者：` +
          `${batting.player.name} ${key} 不正確 ${PAValue} 應為(${batting[key]})`,
      );
    });
  });

  [...awayBox.pitchings, ...homeBox.pitchings].forEach((pitching) => {
    const pitcherUniqid = pitching.player.uniqid;
    if (!PA2Pitchers[pitcherUniqid]) {
      initPA2Pitcher(pitcherUniqid);
    }

    console.log(pitching);
    console.log(PA2Pitchers[pitcherUniqid]);
    R.filter((c) => !!c.updatable && !pitchingIgnoreList.includes(c.column), PitchingColumns).forEach((c) => {
      const key = c.column;
      const PAValue = PA2Pitchers[pitcherUniqid][key];
      if (PAValue === pitching[key]) {
        return;
      }

      errorMessages.push(
        `${R.find((p) => p.player.uniqid === pitcherUniqid, awayBox.pitchings) ? 'AWAY' : 'HOME'} 投手：` +
          `${pitching.player.name} ${key} 不正確 ${PAValue} 應為(${pitching[key]})`,
      );
    });
  });

  PAList.forEach((PA, PAIndex) => {
    const outsInPA = R.filter((r) => r.is_out, PA.runners).length;
    if (PA.end_outs > 3 || outsInPA !== PA.end_outs - PA.start_outs) {
      errorMessages.push(
        `出局, 結束出局 錯誤： ${PA.inning}局 ${PA.side} 第${PA.PA_round}輪第${PA.PA_order}棒 ${PA.batter.name}`,
      );
    }
    if (PAIndex !== 0 && PAList[PAIndex - 1].side !== PA.side && (PA.start_outs !== 0 || PA.outs !== 0)) {
      errorMessages.push(
        `出局, 結束出局 錯誤： ${PA.inning}局 ${PA.side} 第${PA.PA_round}輪第${PA.PA_order}棒 ${PA.batter.name}`,
      );
    }
    if (
      PAList[PAIndex + 1] &&
      PAList[PAIndex + 1].inning === PA.inning &&
      PAList[PAIndex + 1].side === PA.side &&
      PAList[PAIndex + 1].start_outs !== PA.end_outs
    ) {
      errorMessages.push(
        `出局, 結束出局 錯誤： ${PA.inning}局 ${PA.side} 第${PA.PA_round}輪第${PA.PA_order}棒 ${PA.batter.name}`,
      );
    }

    const runnerIDs = R.flatten(PA.events.map((e) => [e.first?.uniqid, e.second?.uniqid, e.third?.uniqid]));
    if (runnerIDs.includes(PA.batter.uniqid)) {
      errorMessages.push(
        `打席事件 - 壘包 錯誤： ${PA.inning}局 ${PA.side} 第${PA.PA_round}輪第${PA.PA_order}棒 ${PA.batter.name}`,
      );
    }

    if (PA.result === '') {
      return;
    }
    if (PA.is_scoring) {
      const scoreInLastEvent =
        R.filter((r) => r.event_index === PA.events.length - 1 && r.is_scoring, PA.runners).length > 0;
      if (scoreInLastEvent && PA.away_score === PA.end_away_score && PA.home_score === PA.end_home_score) {
        errorMessages.push(
          `開始得分, 得分, 結束得分 錯誤： ${PA.inning}局 ${PA.side} 第${PA.PA_round}輪第${PA.PA_order}棒 ${PA.batter.name}`,
        );
      } else if (!scoreInLastEvent && (PA.away_score !== PA.end_away_score || PA.home_score !== PA.end_home_score)) {
        errorMessages.push(
          `開始得分, 得分, 結束得分 錯誤： ${PA.inning}局 ${PA.side} 第${PA.PA_round}輪第${PA.PA_order}棒 ${PA.batter.name}`,
        );
      }
    } else if (
      PA.start_away_score !== PA.away_score ||
      PA.away_score !== PA.end_away_score ||
      PA.start_home_score !== PA.home_score ||
      PA.home_score !== PA.end_home_score
    ) {
      errorMessages.push(
        `開始得分, 得分, 結束得分 錯誤： ${PA.inning}局 ${PA.side} 第${PA.PA_round}輪第${PA.PA_order}棒 ${PA.batter.name}`,
      );
    }

    // 處理有沒有出局的檢查
    const outInLastEvent = R.filter((r) => r.event_index === PA.events.length - 1 && r.is_out, PA.runners).length > 0;
    if ((outInLastEvent && PA.outs === PA.end_outs) || (!outInLastEvent && PA.outs !== PA.end_outs)) {
      errorMessages.push(
        `出局, 結束出局 錯誤： ${PA.inning}局 ${PA.side} 第${PA.PA_round}輪第${PA.PA_order}棒 ${PA.batter.name}`,
      );
    }
  });

  return {
    missingMessages,
    errorMessages,
  };
};
